// extracted by mini-css-extract-plugin
export default {"label":"EmployeeCheckboxLabel--label--4aaa2e","avatar":"EmployeeCheckboxLabel--avatar--cffd07"};